import React from "react";
import { NewTab, PageHeader, PageTab, PageTitle } from "../../../../components";
import Active from "./Placements/Active";
import Inactive from "./Placements/Inactive";

const Placements = ({ isEditable, editClient, clientId }) => {
  const placementsMenus = [
    {
      title: "Active",
      page: (
        <Active
          isEditable={isEditable}
          editClient={editClient}
          clientId={clientId}
        />
      ),
      type: "main",
    },
    {
      title: "Inactive",
      page: (
        <Inactive
          isEditable={isEditable}
          editClient={editClient}
          clientId={clientId}
        />
      ),
      type: "main",
    },
  ];
  return (
    <>
      <div className="py-3 px-3 h-full">
        <div className="mb-6">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"Placements"} icon={"badge"} tag="h5" />
              </div>
            }
          />
        </div>
        <div>
          <NewTab
            tabs={placementsMenus}
            color="black"
            variant="text"
            activeVariant="text"
            mode="url"
            tabId="placements"
          />
        </div>
      </div>
    </>
  );
};

export default Placements;
